export class AppintmentData {
    "firstname":"";
    "lastname":"";
    "dob":"";
    "age":"";
    "gender":"";
    "phone":"";
    "email":"";
    "description":"";
    "address":"";
    "occupation":"";
    "_teamId":""
 }